import { TabBookingAbstract } from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/tabBookingAbstract'
import { Office } from '@/class/model/sys/Office'
import $store from '@/store'
import { Company } from '@/class/model/mdm/Company'
import { User } from '@/class/model/sys/User'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
import { TabError } from '@/utils/class/TabError'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import StrUtils from '@/utils/StrUtils'
import { Contract } from '@/class/model/mdm/Contract'
import { Customer } from '@/class/model/mdm/Customer'
import * as OverseaAgentGrade from '@/class/cargo/model/parameters/OverseaAgentGrade'
import { ImportConstants } from '@/class/cargo/model/utils/ImportConstants'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'
import { SeaImCargoDoc } from '@/class/model/booking/SeaImCargoDoc'
import { OverseaCustomerUtils } from '@/class/cargo/model/utils/OverseaCustomerUtils'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export class BasicTabHP extends TabBookingAbstract {
  constructor(view) {
    super(view)
    this.isSpecifiedSalesBusiness = false // 是否启用合作伙伴对应的服务人员设置(多销售模式)
    this.customerDefaultCargoSource = false //
  }

  get job() {
    return this.view.job
  }
  set job(job) {
    this.view.job = job
  }

  // 填充表单
  fillView() {
    const job = this.view.job
    if (!job) return
    //
    this.initStaticVariables()
    // 判断是否有主票信息
    if (job.lclMasterUuid) {
      this.view.lclMasterFlag = true
    } else {
      this.view.lclMasterFlag = this.view.isEdit
    }
    if (!job.jobNo) {
      if (job.containerLoadType === 'LCL') {
        job.freightTermHBL = 'CFS-CFS'
      } else {
        job.freightTermHBL = 'CY-CY'
      }
    }
    if (job.seaEQ && job.seaEQ.length > 0) {
      this.view.seaEqList = job.seaEQ
    }
    this.loadUserData()
    this.loadCompanyOffice()
    this.loadCustomerContacts()
    if (!job.uuid) {
      JobUtils.matchUserPortConfig(this.view, job)
      JobUtils.matchRegionWarehouseMappingConfig(job, null, false, null, null, true)
    } else {
      JobUtils.matchUserPortConfig(this.view, job, false, null, { keepOriginValue: true })
    }
  }
  // 初始化静态变量
  initStaticVariables() {
    // 联系人
    this.view.contactList = []
    // 销售分公司
    this.view.txtSalesOffice = ''
    // 是否小票
    this.view.lclMasterFlag = false
    // 是否启用合作伙伴对应的服务人员设置(多销售模式)
    this.isSpecifiedSalesBusiness = Number(this.config.get('IsSpecifiedSalesBusiness')) === 1
    // 是否按照分公司控制 (1:开启分公司过滤 0:关闭分公司过滤)
    this.view.salesOfficeCheck = Number(this.config.get('SalesOfficeCheck')) === 1
    //
    this.customerDefaultCargoSource = Number(this.config.get('CustomerDefaultCargoSource')) === 1
    //
    this.view.seaEqList = []
    this.view.needConfirmProjectNo = Number(this.config.get('needConfirmProjectNo')) === 1
    this.view.isZY = String(this.config.get('ToExoSystem')) === 'zy' // 显示中邮选项
  }
  // 销售分公司文本框
  async loadCompanyOffice() {
    const job = this.job
    const office = await Office.getOfficeById(job.salesOffice)
    if (office) {
      this.view.txtSalesOffice = $store.getters.language === 'zh' ? office.chineseName : office.englishName
    } else {
      this.view.txtSalesOffice = ''
    }
  }
  // 合作伙伴对应多销售
  async loadCompanyMultiSales() {
    if (this.isSpecifiedSalesBusiness) {
      const job = this.view.job
      const company = await Company.getCompanyById(job.customerId)
      if (company) {
        await Company.getCompanyUsers(company.uuid).then(data => {
          this.loadCompanyUserHandler(data)
        })
      }
    }
  }
  // 计费重量变化
  chargeWeightChangeHandler() {
    SeaImCargoDoc.changeSynDataQWC(new SeaImportJob(this.job), true)
  }
  // 处理销售相关信息
  async loadCompanyUserHandler(companyUsers) {
    const job = this.job
    // 销售数据源
    const salesList = []
    let salesDefaultId = 0
    // 揽货销售
    const cargoSalesList = []
    let cargoSalesId = 0
    // 操作
    const opList = []
    let opDefaultId = 0
    // 海外客服
    const overseaOpList = []
    let overseaOpDefaultId = 0
    // 如果开启分公司过滤参数，查出来所有分公司
    let officeSaleList = []
    if (this.view.salesOfficeCheck) {
      officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', $store.getters.currentOfficeId, true)
    }
    if (companyUsers && companyUsers.length > 0) {
      for (const u of companyUsers) {
        if (!u.lob || u.lob === job.lob || u.lob === 'ALL') {
          const user = this.userList.find(p => p.userId === u.userId)
          if (user && user.active) {
            if (u.roleType === CargoOfRoleType.SALES_TYPE.code) { // 销售
              if (this.view.salesOfficeCheck) {
                for (const obj of officeSaleList) {
                  if (user.userId === obj.userId) {
                    if (u.defaultUser) {
                      salesDefaultId = u.userId
                    }
                    salesList.push(user)
                  }
                }
              } else {
                if (u.defaultUser) {
                  salesDefaultId = u.userId
                }
                salesList.push(user)
              }
            } else if (u.roleType === CargoOfRoleType.SALES_OF_GOODS.code) { // 揽货销售
              if (u.defaultUser) {
                cargoSalesId = u.userId
              }
              cargoSalesList.push(user)
            } else if (u.roleType === CargoOfRoleType.OP_TYPE.code) { // 操作
              if (u.defaultUser) {
                opDefaultId = u.userId
              }
              opList.push(user)
            } else if (u.roleType === CargoOfRoleType.OVERSEAOP_TYPE.code) { // 海外客服
              if (u.defaultUser) {
                overseaOpDefaultId = u.userId
              }
              overseaOpList.push(user)
            }
          }
        }
      }
    }
    // 自揽货时进行销售变更;指定货以指定货代理为准
    if (job.cargoSource !== CargoSource.NC_CARGO_SOURCE.code) {
      this.view.salesList = salesList
      this.getTxtSalesPrompt()
      if (salesList.length > 0) {
        if (salesDefaultId > 0) {
          job.sales = salesDefaultId
        } else {
          job.sales = salesList[0].userId
        }
        this.view.$nextTick(() => {
          const user = this.userList.find(p => p.userId === job.sales)
          if (user) {
            this.salesChangeHandler({ ...user, value: user.userId })
          }
        })
      } else {
        // job.sales = 0
        // job.salesDepartment = 0
        // this.view.txtSalesOffice = ''
      }
    }
    // 揽货销售
    if (cargoSalesList.length > 0) {
      if (cargoSalesId > 0) {
        job.cargoSalesId = cargoSalesId
      } else {
        job.cargoSalesId = cargoSalesList[0].userId
      }
      this.view.$nextTick(() => {
        const user = this.userList.find(p => p.userId === job.cargoSalesId)
        this.cargoSalesChargeHandler({ ...user, value: user.userId })
      })
    } else {
      // job.cargoSalesId = 0
      // job.cargoSalesOffice = 0
      // job.cargoSalesDepartment = 0
    }
    if (this.view.isHC) {
      // 操作
      if (opList.length > 0) {
        if (opDefaultId > 0) {
          job.op = opDefaultId
        } else {
          job.op = opList[0].userId
        }

        const user = await User.getUserById(job.op)
        this.view.$nextTick(() => {
          this.opChange({ ...user, value: user.userId })
        })
      } else {
        // job.op = 0
        // job.opDepartment = 0
      }
      // 海外客服
      if (overseaOpList.length > 0) {
        if (overseaOpDefaultId > 0) {
          job.overseaOp = overseaOpDefaultId
        } else {
          job.overseaOp = overseaOpList[0].userId
        }

        const user = await User.getUserById(job.overseaOp)
        this.view.$nextTick(() => {
          OverseaCustomerUtils.overseaOpChangeHandler(this.view, { ...user, value: user.userId })
        })
      } else {
        // job.overseaOp = 0
        // job.overseaOpDepartment = 0
      }
    }
  }
  // 销售下拉框提示信息
  getTxtSalesPrompt() {
    if (this.isSpecifiedSalesBusiness && this.view.salesList && this.view.salesList.length === 0) {
      this.view.salesPrompt = this.view.$t('SeaExport.PleaseMaintainTheCorrespondingSalesInThePartner')
    } else {
      this.view.salesPrompt = ''
    }
  }
  // 揽货类型修改事件
  async cargoSourceChange(data) {
    const job = this.view.job
    job.cargoSource = data || ''
    job.designationAgent = 0
    if (job.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
      this.customerIdChangeNew()
    } else {
      // 货物类型变为指定货时，重置销售列表
      if (this.view.salesOfficeCheck) {
        this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', $store.getters.currentOfficeId, true)
      } else {
        this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', null, true)
      }
    }
    OverseaCustomerUtils.designationAgentOrCargoSourceChangeHandler(this.view)
  }
  // 委托单位选择（从写委托单位选择，去掉当前与分公司校验）
  async customerIdChangeNew() {
    const job = this.view.job
    if (!job) return
    const company = await Company.getCompanyById(job.customerId)
    let changeFlag = false
    if ((!company && job.customerId > 0) || company) {
      changeFlag = true
    }
    job.customerRemarks = company ? company.chineseName : ''
    if (job.cargoSource === CargoSource.SC_CARGO_SOURCE.code && !job.masterFlag) {
      this.loadCustomerDetail()
    }
    if (company && changeFlag) {
      this.loadCompanyUser()
      this.loadCustomerContacts()
      this.loadCustomerSales()
    } else {
      job.salesOffice = 0
      job.sales = 0
      job.salesDepartment = 0
      if (this.view.salesOfficeCheck) {
        this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', $store.getters.currentOfficeId, true)
      } else {
        this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', null, true)
      }
      this.getTxtSalesPrompt()
    }
  }
  // 加载委托单位维护的客户详情
  async loadCustomerDetail() {
    const job = this.view.job
    if (!job) return
    const company = await Company.getCompanyById(job.customerId)
    if (company) {
      const customerDetail = await new Company(company).getCustomerDetail()
      if (customerDetail && customerDetail.sales > 0 && !this.IsSpecifiedSalesBusiness) {
        const user = await User.getUserById(customerDetail.sales)
        if (user && user.active) {
          if (this.view.salesOfficeCheck) {
            job.sales = 0
            const userList = this.view.salesList
            if (userList && userList.length > 0) {
              for (const u of userList) {
                if (user.userId === u.userId) {
                  job.sales = u.userId
                  break
                }
              }
            }
          } else {
            job.sales = user.userId
          }
        }
      }
    }
  }
  // 加载销售
  async loadCompanyUser() {
    if (this.isSpecifiedSalesBusiness) {
      const company = await Company.getCompanyById(this.job.customerId)
      if (company) {
        Company.getCompanyUsers(company.uuid).then(data => {
          this.loadCompanyUserHandler(data)
        })
      } else {
        this.job.salesOffice = 0
        if (this.view.salesOfficeCheck) {
          this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', $store.getters.currentOfficeId, true)
        } else {
          this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', null, true)
        }
      }
    }
  }
  /**
   * 加载客户销售
   */
  async loadCustomerSales() {
    const company = this.companyList.find(p => p.cmpIdx === this.job.customerId)
    if (company) {
      if (!this.isSpecifiedSalesBusiness && this.job.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
        // 加载销售
        if (this.view.salesOfficeCheck) {
          this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.view.$store.getters.currentOfficeId, true)
        } else {
          this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', null, true)
        }

        await new Company(company).getCustomerDetail()

        if (company.customerDetail !== null) {
          if (company.customerDetail.sales > 0) {
            const salseTemp = company.customerDetail.sales
            const user = this.userList.find(p => p.userId === salseTemp)

            if (user && user.active) {
              if (this.view.salesOfficeCheck) {
                const userList = this.view.salesList
                this.job.sales = 0
                for (const obj of userList) {
                  if (user.userId === obj.userId) {
                    this.job.sales = salseTemp
                  }
                }
              } else {
                this.job.sales = salseTemp
              }
              this.salesChangeHandler({ ...user, value: this.job.sales })
            }
          } else {
            this.job.salesOffice = 0
            this.job.sales = 0
            this.job.salesDepartment = 0
          }
        }
      }
    }
  }
  // 加载联系人
  async loadCustomerContacts() {
    const company = await Company.getCompanyById(this.job.customerId)
    this.view.contactList = []
    if (!company || !this.job.customerId || company.cmpIdx !== this.job.customerId) {
      return
    }
    this.view.contactList = await new Company(company).getContacts()
    if (company && this.view.contactList && this.view.contactList.length > 0) {
      if (StrUtils.isEmpty(this.job.customerContact)) {
        const contact = this.getDefaultContact(this.view.contactList)
        this.job.customerContact = contact ? contact.contactPerson : ''
        this.job.contactFax = contact ? contact.fax : ''
        this.job.contactTelephone = contact ? contact.telephone : ''
      }
    } else {
      this.job.customerContact = ''
      this.job.contactFax = ''
      this.job.contactTelephone = ''
    }
  }
  // 获取默认联系人
  getDefaultContact(ary) {
    let rs = null
    if (ary && ary.length > 0) {
      rs = ary[0]
      for (const contact of ary) {
        if (contact.defaultContact) {
          rs = contact
          break
        }
      }
    }
    return rs
  }
  // 委托单位修改事件
  async customerIdChange(data) {
    const job = this.view.job
    if (!job) return
    this.view.cargoSalesList = null
    job.customerId = data ? data.value : 0
    const company = await Company.getCompanyById(job.customerId)
    if (company) {
      // 中邮委托单位是否黑名单
      const blacklist = await JobUtils.checkBlacklistByCustomerId(company.cmpIdx)
      if (blacklist) {
        // return
      }
      const isForbid = await Contract.isContractExpiredForbidCreateJob(job.customerId)
      if (isForbid) {
        job.customerId = 0
        this.view.$message.warning('该委托单位合同到期，不能再创建业务！')
        job.customerRemarks = ''
        return
      }
    }
    await this.customerIdChangeHandler()
    JobUtils.loadCompanyCargoSales(this.view, job, this.isSpecifiedSalesBusiness, true)
  }
  async customerIdChangeHandler() {
    const job = this.view.job
    if (!job) return
    job.editCftMode = false
    const company = await Company.getCompanyById(job.customerId)
    if (company) {
      await this.loadCompanyUser()
      await this.loadCustomerSales()
      this.onCustomerDetailLoad()
      this.loadCustomerContacts()
      if (company.mustInputScn) {
        job.editCftMode = true
      }
    } else {
      job.customerId = 0
      job.sales = 0
      job.salesOffice = 0
      job.salesDepartment = 0
      this.view.txtSalesOffice = ''
      if (this.view.salesOfficeCheck) {
        this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', $store.getters.currentOfficeId, true)
      } else {
        this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', null, true)
      }
      this.getTxtSalesPrompt()
    }
    job.customerRemarks = company ? company.chineseName : ''
  }
  // 加载客户信息
  async onCustomerDetailLoad() {
    const job = this.view.job
    if (!job) return
    const company = await Company.getCompanyById(job.customerId)
    if (company) {
      const customerDetail = await new Company(company).getCustomerDetail()
      if (customerDetail && customerDetail.designated && customerDetail.seftCanvass) {
        if (!this.customerDefaultCargoSource) {
          this.loadCustomerDetailSales(job.customerId) // //自揽货取客户
        } else {
          this.loadOverseaAgentDetailOwner(job.designationAgent) // 指定货取指定货代理
        }
      } else {
        if (customerDetail.designated) {
          this.loadOverseaAgentDetailOwner(job.designationAgent) // 指定货取指定货代理
        } else if (customerDetail.seftCanvass) {
          this.loadCustomerDetailSales(job.customerId) // //自揽货取客户
        }
        // if (job.cargoSource !== CargoSource.SC_CARGO_SOURCE.code) {
        //   job.designationAgent = 0
        // }
        await new Customer(customerDetail).getSpecialRequests()
      }
    }
  }
  // 自揽货 -> 加载销售(如果合作伙伴服务人员有多个则不刷新)
  async loadCustomerDetailSales(companyId) {
    const job = this.view.job
    const company = await Company.getCompanyById(companyId)
    if (company) {
      const customerDetail = await new Company(company).getCustomerDetail()
      if (customerDetail) {
        const user = await User.getUserById(customerDetail.sales)
        if (user && user.active) {
          if (this.view.salesOfficeCheck) {
            const userList = this.view.salesList
            job.sales = 0
            for (const u of userList) {
              if (user.userId === u.userId && user.active) {
                job.sales = user.userId
              }
            }
          } else {
            job.sales = user.userId
          }
        }
      } else {
        job.sales = 0
      }
    } else {
      job.sales = 0
    }
  }
  // 指定货 -> 加载网管
  async loadOverseaAgentDetailOwner(companyId) {
    const company = await Company.getCompanyById(companyId)
    // 货物类型变为指定货时，重置销售列表
    if (this.view.salesOfficeCheck) {
      this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', $store.getters.currentOfficeId, true)
    }
    if (company) {
      const overseaAgentDetail = await new Company(company).getOverseaAgentDetail()
      this.loadOverseaAgentDetailOwnerHandler(overseaAgentDetail)
    }
  }
  // 加载海外代理
  loadOverseaAgentDetailOwnerHandler(overseaAgentDetail) {
    if (overseaAgentDetail) {
      // 添加指定货代理等级
      const overseaAgentGrade = OverseaAgentGrade.getOverseaAgentGradeByCode(overseaAgentDetail.grade)
      if (overseaAgentGrade) {
        this.job.agentLevel = overseaAgentGrade.chineseName
      }
      if (this.view.salesOfficeCheck) {
        const userList = this.view.salesList
        if (userList && userList.length > 0) {
          for (const u of userList) {
            if (u.userId === overseaAgentDetail.owner && u.active) {
              this.job.sales = overseaAgentDetail.owner
            }
          }
        }
      } else {
        this.job.sales = overseaAgentDetail.owner
      }
    } else {
      this.job.sales = 0
    }
    this.salesChangeHandler({ value: this.job.sales })
  }
  // 销售修改事件
  async salesChangeHandler(data) {
    const job = this.job
    job.sales = data.value
    job.salesOffice = 0
    this.view.txtSalesOffice = ''
    job.salesDepartment = 0
    if (data.value) {
      if (data.defaultOfficeId) { // 用户设置了默认公司和部门就用默认的
        job.salesOffice = data.defaultOfficeId
        job.salesDepartment = data.defaultDepId
        const office = await Office.getOfficeById(job.salesOffice)
        this.view.txtSalesOffice = $store.getters.language === 'zh' ? office.chineseName : office.englishName
      } else {
        const offices = await User.getUserDepartmentOffices('role', 'sales', data.value)
        if (offices.length > 1) {
          for (const item of offices) {
            if (this.view.branchOfficeCheck || (!this.view.branchOfficeCheck && item.officeId === this.context.office.officeId)) {
              job.salesOffice = item.officeId
              job.salesDepartment = item.departmentId
              this.loadCompanyOffice()
              break
            }
          }
        } else {
          const user = new User(data)
          const department = await user.getDefaultDepartment('role', 'sales')
          if (department) {
            const office = await Office.getOfficeByUuid(department.officeUuid)
            job.salesOffice = office.officeId
            job.salesDepartment = department.departmentId
            this.view.txtSalesOffice = $store.getters.language === 'zh' ? office.chineseName : office.englishName
          }
        }
      }
    }
  }
  // 联系人修改事件
  customerContactChange() {
    const job = this.view.job
    const contact = this.view.contactList.find(item => item.contactPerson === job.customerContact)
    if (contact != null) {
      job.contactTelephone = contact.telephone
      job.contactFax = contact.fax
    } else {
      job.contactTelephone = ''
      job.contactFax = ''
    }
  }
  // 整拼类型修改事件
  cargoTypeChange(data) {
    const job = this.view.job
    job.containerLoadType = data ? data.code : ''
    job.masterFlag = false
    if (job.containerLoadType === 'CON') {
      job.masterFlag = true
      this.view.$emit('containerLoadTypeEvent', job)
    } else {
      JobUtils.matchUserPortConfig(this.view, this.view.job)
      JobUtils.matchRegionWarehouseMappingConfig(this.view.job)
    }
  }
  // 重量修改事件
  weightChange() {
    this.job.weightContract = this.job.weightActual
    this.calculateChargeWeight()
  }
  // 体积修改事件
  cubageChange() {
    this.job.cubageContract = this.job.cubageActual
    this.calculateChargeWeight()
  }
  quantityChange() {
    this.job.quantityContract = this.job.quantityActual
  }
  // 计算计费重量
  calculateChargeWeight() {
    const chargeWeight = this.job.weightContract / 1000
    if (isNaN(this.job.cubageContract) && isNaN(this.job.weightContract)) {
      this.job.chargeWeight = 0
      return
    }
    if (isNaN(this.job.cubageContract)) {
      this.job.chargeWeight = chargeWeight
      return
    }
    if (isNaN(this.job.weightContract)) {
      this.job.chargeWeight = this.job.cubageContract
      return
    }
    if (chargeWeight > this.job.cubageContract) {
      this.job.chargeWeight = chargeWeight
    } else {
      this.job.chargeWeight = this.job.cubageContract
    }
  }
  /**
   * 卸货港选择
   */
  async dischargingPortCodeChange(evt) {
    const job = this.job
    if (Number(this.config.get('SyncPOD')) === 1) {
      job.destinationPortCode = job.dischargingPortCode
    } else {
      job.destinationPortCode = job.destinationPortCode || job.dischargingPortCode
    }
    const seaPorts = await getSpecificBasicData(basicCacheKeys.basic_data_Seaport)
    const selPort = seaPorts.filter(p => p.code === job.dischargingPortCode)
    if (selPort && selPort.length > 0) {
      // 开启配置项后交货地变更不会带到最终目的地1开启 0关闭(默认)
      if (parseInt(this.config.get('FinalDestinationChange')) === 1) {
        job.destinationPlace = selPort[0].englishName
      }
    }
    JobUtils.matchUserPortConfig(this.view, this.view.job)
    JobUtils.matchRegionWarehouseMappingConfig(this.view.job)
  }
  // 指定货代理修改事件
  async designationAgentChange(data) {
    const job = this.view.job
    job.designationAgent = data ? data.value : ''
    if (job.designationAgent > 0) {
      const company = await Company.getCompanyById(job.designationAgent)
      if (company) {
        this.loadOverseaAgentDetailOwner(job.designationAgent)
      }
    }
    OverseaCustomerUtils.designationAgentOrCargoSourceChangeHandler(this.view)
  }
  txtDestinationAgentChangeHandler(data) {
    const job = this.job
    job.destinationAgent = data.value
    OverseaCustomerUtils.destinationAgentChangeHandler(this.view)
  }
  // 操作修改事件
  opChange(data) {
    const job = this.view.job
    job.op = data ? data.value : 0
    job.opDepartment = 0
    if (data.defaultDepId > 0) {
      job.opDepartment = data.defaultDepId
    } else {
      const dep = new User(data).getUserDefaultDepartmentByOffice('role', 'siop', job.opOffice)
      job.opDepartment = dep ? dep.departmentId : 0
    }
  }
  async hblFunction() {
    if (this.job) {
      const hawb = await new SeaImportJob(this.job).getMainHbl(false)
      if (hawb) {
        hawb.hblNbr2 = this.job.hbl
      }
    }
  }
  // 销售部门修改事件
  async salesDepartmentChange(data) {
    const job = this.view.job
    job.salesDepartment = data ? data.value : 0
    const office = await Office.getOfficeByUuid(data.officeUuid)
    if (office && office.officeId !== job.salesOffice) {
      job.salesOffice = office.officeId
      this.loadCompanyOffice()
    }
  }
  // 客户修改事件
  async csrChange(data) {
    const job = this.view.job
    job.csr = data ? data.value : 0
    job.csrOffice = 0
    job.csrDepartment = 0
    if (job.csr > 0) {
      const user = new User(data)
      const dep = await user.getDefaultDepartment('role', 'csr')
      const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
      job.csrDepartment = dep ? dep.departmentId : 0
      job.csrOffice = office ? office.officeId : 0
    }
  }
  // 单证修改事件
  async dcChange(data) {
    const job = this.view.job
    job.dc = data ? data.value : 0
    job.dcDepartment = 0
    job.dcOffice = 0
    if (job.dc > 0) {
      const user = new User(data)
      const dep = await user.getDefaultDepartment('role', 'doc')
      const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
      job.dcDepartment = dep ? dep.departmentId : 0
      job.dcOffice = office ? office.officeId : 0
    }
  }
  // 航线负责人修改事件
  async plannerChange(data) {
    const job = this.view.job
    job.planner = data ? data.value : 0
    job.plannerDepartment = 0
    job.plannerOffice = 0
    if (job.planner > 0) {
      const user = new User(data)
      const dep = await user.getDefaultDepartment('role', 'sealine')
      job.plannerDepartment = dep ? dep.departmentId : 0
      const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
      job.plannerOffice = office ? office.officeId : 0
    }
  }
  // 保存时，填充job
  async fillModel() {
    const job = this.view.job
    job.jobState = -1
    job.masterFlag = false
    job.signHBL = true
    job.signMBL = true
    job.opOffice = $store.getters.currentOfficeId
    job.lob = 'SI'
    if (!job.csr) {
      job.csrDepartment = 0
      job.csrDepartment = 0
    }
    if (!job.dc) {
      job.dcDepartment = 0
      job.dcOffice = 0
    }
    if (!job.salesDepartment || !job.salesOffice) {
      const sales = await User.getUserById(job.sales)
      if (sales) {
        const dev = await new User(sales).getDefaultDepartment('role', 'sales')
        if (dev) {
          job.salesDepartment = dev.departmentId
          const office = await Office.getOfficeByUuid(dev.officeUuid)
          job.salesOffice = office ? office.officeId : 0
        } else {
          job.salesDepartment = 0
          job.salesOffice = 0
        }
      }
    }
    // 下面代码一堆bug 实际也不用重新算箱子
    // 增加箱型箱量信息,重写老cargo中SEAIMContainerUtil.updateContainerUsages(_importJob);
    // 1. 删除原有的containerUsages
    // const delContainerUsageUuids = []
    // const containerUsages = job.containerUsages
    // if (containerUsages && containerUsages.length > 0) {
    //   for (const usage of containerUsages) {
    //     delContainerUsageUuids.push(usage.uuid)
    //   }
    // }
    // if (delContainerUsageUuids.length > 0) {
    //   job.delContainerUsageUuids = delContainerUsageUuids
    // }
    // // 2. 删除原有的containers
    // const delContainerUuids = []
    // const containers = job.containers
    // if (containers && containers.length > 0) {
    //   for (const container of containers) {
    //     delContainerUuids.push(container.uuid)
    //   }
    // }
    // if (delContainerUuids.length > 0) {
    //   job.delContainerUuids = delContainerUuids
    // }
    // // 3.根据箱子信息，生成新的containerUsages
    // if (job.seaEQ && job.seaEQ.length > 0) {
    //   for (const seaEq of job.seaEQ) {
    //     if (seaEq.eqSize) {
    //       const quantity = seaEq.eqQuantity
    //       if (quantity === 1) {
    //         this.addNewContainerUsage(job, seaEq)
    //       } else {
    //         for (let i = 0; i < quantity; i++) {
    //           this.addNewContainerUsage(job, seaEq)
    //         }
    //       }
    //     }
    //   }
    // }
    // 保存提单地址
    if (parseInt(this.config.get('syncMailingAddress')) === 1) {
      ImportConstants.saveBillAddress(this.job)
    }
  }
  // 增加 ContainerUsage 和containers 值
  // addNewContainerUsage(job, seaEq) {
  //   if (!seaEq) return
  //   const containerUsages = []
  //   const containers = []
  //   const u = new ContainerUsage().fillDefaultValue().getData()
  //   u.jobUuid = job.uuid
  //   const container = new Container().fillDefaultValue().getData()
  //   container.jobUuid = job.uuid
  //   container.sealNo = seaEq.sealNo
  //   container.remark = ''
  //   container.containerNo = seaEq.containerNo
  //   container.EQsize = seaEq.eqSize
  //   container.EQtype = seaEq.eqType
  //   container.truckingInfoUuid = null
  //   container.truckingFee = null
  //   container.containerUsage = []
  //   container.containerUsage.push(u)
  //   u.container = container
  //   u.quantity = seaEq.eqQuantity
  //   u.weight = 0
  //   u.cubage = 0
  //   // 数据库中本票业务关联的箱子
  //   const originalContainerUsages = job.containerUsages
  //   if (originalContainerUsages && originalContainerUsages.length > 0) {
  //     for (const usage of originalContainerUsages) {
  //       if (container.eqSize === usage.eqSize && container.eqType === usage.eqType && container.containerNo === usage.containerNo && container.sealNo === usage.sealNo) {
  //         container.truckingInfoUuid = u.truckingInfoUuid
  //         container.truckingFee = u.truckingFee
  //         break
  //       }
  //     }
  //   }
  //   containers.push(container)
  //   containerUsages.push(u)
  //   //
  //   job.containers = containers
  //   job.containerUsages = containerUsages
  // }
  // 提交数据时验证表单
  async validateForm() {
    const form = this.view.job
    if (form.customerId < 1) {
      if (this.view.visibleDesignationAgent) {
        throw new TabError(this.view.$t('SeaExport.checkActualNotifyParty'), 'basicTab')
      } else {
        throw new TabError(this.view.$t('SeaExport.checkConsignationCompany'), 'basicTab')
      }
    }
    await JobUtils.checkCustomerBranchScope(form, 'basicTab')

    if (!form.opDepartment || form.opDepartment === 0) {
      throw new TabError(this.view.$t('queryJob.OperationDepartmentCannotBeEmpty'), 'basicTab')
    }

    if (this.view.visibleDesignationAgent) {
      if (form.designationAgent < 1) {
        throw new TabError(this.view.$t('SeaExport.checkNominatedAgent'), 'basicTab')
      }
    }

    if (!form.loadingPortCode) {
      throw new TabError(this.view.$t('SeaExport.checkLoadingPort2'), 'basicTab')
    }

    if (!form.dischargingPortCode) {
      throw new TabError(this.view.$t('SeaExport.checkPortOfDischarge'), 'basicTab')
    }

    if (!form.destinationPortCode) {
      throw new TabError(this.view.$t('Message.PlaceOfDeliveryCannotBeNull'), 'basicTab')
    }

    // if (!form.destinationPlace) {
    //   throw new TabError(this.view.$t('SeaExport.checkFinalDestination'), 'basicTab')
    // }

    if (form.etd && form.eta && form.eta < form.etd) {
      throw new TabError(this.view.$t('SeaExport.checkDateOfDepartureAndDateOfArrival'), 'basicTab')
    }
    if (!SecurityUtil.customerIsOwn(form.customerId) && !form.uuid) {
      throw new TabError(this.view.$t('CargoMsg.Cargo_CustomerNotOwn'), 'basicTab')
    }
    // 中邮定制字段 保存校验
    if (this.view.isZY && !form.saleProductCode) {
      throw new TabError(this.view.$t('Message.SaleProductCodeCannotBeNull'), 'basicTab')
    }
    if (this.view.isZY && !form.fullOrInside) {
      throw new TabError(this.view.$t('Message.FullOrInsideCannotBeNull'), 'basicTab')
    }
  }
  /**
   * 收货人代码
   */
  qConsigneeCode_focusOutHandler() {
    if (!this.job.notifyCode) {
      this.job.notifyCode = this.job.consigneeCode
    }
  }
  /**
   * 收货人地址
   */
  qConsigneeAddr_focusOutHandler() {
    if (!this.job.notifyLine1) {
      this.job.notifyLine1 = this.job.consigneeLine1
    }
  }
  async loadUserData() {
    if (!this.isSpecifiedSalesBusiness) {
      if (this.view.salesOfficeCheck) {
        this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', $store.getters.currentOfficeId, true)
      } else {
        this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', null, true)
      }
    } else {
      const company = this.companyList.find(p => p.cmpIdx === this.job.customerId)
      if (company) {
        Company.getCompanyUsers(company.uuid).then(data => {
          this.loadUserHandler(data)
        })
      } else {
        if (this.view.salesOfficeCheck) {
          this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', $store.getters.currentOfficeId, true)
        } else {
          this.view.salesList = await User.getUsersByPrivilegeDetail('role', 'sales', '', null, true)
        }
        this.getTxtSalesPrompt()
      }
    }
  }
  async loadUserHandler(companyUsers) {
    const salesList = []
    // 如果开启分公司过滤参数，查出来所有分公司
    let officeSaleList = []
    if (this.view.salesOfficeCheck) {
      officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.view.$store.getters.currentOfficeId, true)
    }
    if (companyUsers !== null && companyUsers.length > 0) {
      for (const u of companyUsers) {
        if (u.lob === this.job.lob || StrUtils.isEmpty(u.lob) || u.lob === 'ALL') {
          const user = this.userList.find(p => p.userId === u.userId)
          if (user != null) {
            if (u.roleType === CargoOfRoleType.SALES_TYPE.code) {
              if (this.view.salesOfficeCheck) {
                for (const obj of officeSaleList) {
                  if (user.userId === obj.userId) {
                    salesList.push(user)
                  }
                }
              } else {
                salesList.push(user)
              }
            }
          }
        }
      }
    }
    this.view.salesList = salesList
    this.getTxtSalesPrompt()
  }

  destinationPortCodeEasyChange(data) {
    // 开启配置项后交货地变更不会带到最终目的地1开启 0关闭(默认)
    if (parseInt(this.config.get('FinalDestinationChange')) === 1) {
      this.job.destinationPlace = data.englishName
    }
  }

  async cargoSalesChargeHandler(data) {
    const job = this.job
    job.cargoSalesId = data.value || 0
    job.cargoSalesDepartment = 0
    job.cargoSalesOffice = 0
    if (data.value) {
      const offices = await User.getUserDepartmentOffices('role', 'salesOfGoods', data.value)
      if (offices && offices.length > 1) {
        for (const item of offices) {
          if (item.officeId === this.context.office.officeId) {
            const office = await Office.getOfficeById(item.officeId)
            job.cargoSalesOffice = office ? office.officeId : 0
            job.cargoSalesDepartment = item.departmentId
            break
          }
        }
      } else {
        const user = new User(data)
        const department = await user.getDefaultDepartment('role', 'salesOfGoods')
        if (department) {
          job.cargoSalesDepartment = department ? department.departmentId : 0
          const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
          job.cargoSalesOffice = office ? office.officeId : 0
        }
      }
    }
  }

  /**
	 * 起运港修改
	 */
  async loadingPortCodeChange(data) {
    await super.loadingPortCodeChange(data)
    await JobUtils.matchUserPortConfig(this.view, this.job)
    await JobUtils.matchRegionWarehouseMappingConfig(this.job)
  }
}
